import Styles from './styles.module.scss';

import type { Organization as OrganizationModel } from '@/features/Shared/model/types/organization.dto';

interface Props {
	item?: OrganizationModel;
}

export const Organization = ({ item }: Props) => {
	return <span className={Styles.organization}>{item?.name ?? ''}</span>;
};
